import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  IconButton,
  Input,
  Button,
  FormLabel,
  SimpleGrid,
  GridItem,
  Select,
  useToast,
} from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const EditBusStudent = ({ student, allocation_id, RefreshData }) => {
  const { id } = useParams(); // Bus route ID
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({
    name: "",
    pickup: "",
    drop: "",
    startDate: "",
    endDate: "",
    busFee: "",
    fine: "",
    trip: "",

  });
  const [busStops, setBusStops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const toast = useToast();

  // Fetch bus stops
  useEffect(() => {
    const fetchBusStops = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/bus/bus_route/list_stop_names.php?bus_route_id=${id}`
        );
        const data = await response.json();
        if (data.success && Array.isArray(data.data)) {
          setBusStops(data.data);
        } else {
          console.error("Failed to fetch bus stops:", data.message);
        }
      } catch (error) {
        console.error("Error fetching bus stops:", error);
      }
    };
    fetchBusStops();
  }, [id]);

  // Fetch student data
  useEffect(() => {
    const fetchStudentData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${BASE_URL}/admin/bus/students/view_bus_student.php?allocation_id=${allocation_id}&student_id=${student}`
        );
        const data = await response.json();
        console.log("d", data);

        if (data.success && data.data) {
          const studentData = data.data;
          setSelectedStudent({
            name: studentData.name || "",
            pickup: studentData.pickup_location_id || "",
            drop: studentData.drop_location_id || "",
            startDate: studentData.start_date || "",
            endDate: studentData.end_date || "",
            busFee: studentData.bus_fee || "",
            fine: studentData.fine || "",
            dueDate: studentData.due_date || "",
            trip: studentData.trip || "",

          });
        } else {
          console.error("Failed to fetch student data:", data.message);
          setError("Failed to fetch student data.");
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
        setError("An error occurred while fetching student data.");
      } finally {
        setLoading(false);
      }
    };

    if (allocation_id && student) {
      fetchStudentData();
    }
  }, [allocation_id, student]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError(null);
  };

  const handleInputChange = (e, field) => {
    setSelectedStudent({ ...selectedStudent, [field]: e.target.value });
  };

  const saveStudentData = async () => {
    const payload = {
      user_id: sessionStorage.getItem("user_id"),
      school_id: sessionStorage.getItem("school_id"),
      allocation_id: allocation_id,
      pickup_location: selectedStudent.pickup || null,
      drop_location: selectedStudent.drop || null,
      bus_fee: selectedStudent.busFee,
      end_date: selectedStudent.endDate || null,
      start_date: selectedStudent.startDate || null,
      due_date: selectedStudent?.dueDate || null,
      trip: selectedStudent.trip || null,

      student_id: student,
    };
    console.log("payload_edit_students", payload);

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/students/edit_allocation.php`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      console.log("edit_b", result);

      if (result.success) {
        toast({
          title: "Success",
          description: "Student details updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        closeModal();
        RefreshData();
      } else {
        toast({
          title: "Error",
          description: result.message || "Failed to update student details.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while saving student details.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <div>
      <IconButton
        aria-label="Edit student"
        icon={<FaEdit />}
        size="sm"
        colorScheme="blue"
        onClick={openModal}
      />

      <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Student Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading && <p>Loading student data...</p>}
            {error && <p>{error}</p>}
            {!loading && !error && (
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
                <GridItem>
                  <FormLabel>Student Name</FormLabel>
                  <Input
                    placeholder="Enter student name"
                    value={selectedStudent.name}
                    onChange={(e) => handleInputChange(e, "name")}
                    isDisabled
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Pickup Point</FormLabel>
                  <Select
                    placeholder="Select Pick-Up"
                    value={selectedStudent.pickup}
                    onChange={(e) => handleInputChange(e, "pickup")}
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </GridItem>
                <GridItem>
                  <FormLabel>Drop Point</FormLabel>
                  <Select
                    placeholder="Select Drop"
                    value={selectedStudent.drop}
                    onChange={(e) => handleInputChange(e, "drop")}
                  >
                    {busStops.map((stop) => (
                      <option key={stop.id} value={stop.id}>
                        {stop.stop_name}
                      </option>
                    ))}
                  </Select>
                </GridItem>
                <GridItem>
                  <FormLabel>Start Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedStudent.startDate}
                    onChange={(e) => handleInputChange(e, "startDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>End Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedStudent.endDate}
                    onChange={(e) => handleInputChange(e, "endDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Due Date</FormLabel>
                  <Input
                    type="date"
                    value={selectedStudent.dueDate}
                    onChange={(e) => handleInputChange(e, "dueDate")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Bus Fee</FormLabel>
                  <Input
                    placeholder="Enter bus fee"
                    value={selectedStudent.busFee}
                    onChange={(e) => handleInputChange(e, "busFee")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Trip</FormLabel>
                  <Input
                    placeholder="Enter trip details"
                    value={selectedStudent.trip}
                    onChange={(e) => handleInputChange(e, "trip")}
                  />
                </GridItem>
                <GridItem>
                  <FormLabel>Fine</FormLabel>
                  <Input
                    placeholder="Enter fine amount"
                    value={selectedStudent.fine}
                    onChange={(e) => handleInputChange(e, "fine")}
                    isDisabled
                  />
                </GridItem>
              </SimpleGrid>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={saveStudentData}>
              Save
            </Button>
            <Button variant="outline" onClick={closeModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default EditBusStudent;
